// TODO: pull from Settings and elsewhere to determine content of device
// CONSIDER: maybe instead of re-styling things from scratch, just take screenshots?
/*
  announcements - Announcements
  lotto - LottoCard
  sports - Athletics
  coupons - CouponCard
  friends - FriendCard
  specialcard - SpecialCard
  dayevents - DayEvents
  socialmeda - SocialMedia
  newscard - LatestNews
  locationcard - LocationCard
*/

/*
const {
  title = {},
  card = {},
  datecircle = {},
  box = {},
  button = {},
  bottom = {},
  notification = {},
  general = {},
} = theme;
*/

import React, { Component } from 'react';
import styled from 'styled-components';

// icons
import CameraIcon from '@material-ui/icons/Camera';
import FaceIcon from '@material-ui/icons/Face';
import MapIcon from '@material-ui/icons/PinDrop';
import NotifIcon from '@material-ui/icons/Notifications';
import NewsIcon from '@material-ui/icons/LocalLibrary';
import CouponIcon from '@material-ui/icons/LocalOffer';
import FriendIcon from '@material-ui/icons/Mood';
import SpecialIcon from '@material-ui/icons/Stars';


const IPhone = styled.div`
  width: 320px;
  height: 530px;
  background: white;
  border-radius: 5px;
  padding: 20px;
  padding-bottom: 45px;
  position: fixed;
  box-shadow: 0px 2px 3px;
`
const IPhoneScreen = styled.div`
  position: relative;
  overflow-y: scroll;
  border: 1px solid black;
  height: 100%;
  background: ${props => props.background};

  &::-webkit-scrollbar {
    width: 5px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #aaa;
  }
`
const TitleBar = styled.div`
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.styles.background};
  color: ${props => props.styles.color};
`
const LoyaltyCard = styled.div`
  height: 175px;
  display: flex;
  padding: 15px;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background: ${props => props.styles ? props.styles.background : '#537EFF'};
  color: ${props =>  props.styles ? props.styles.color : 'white'};
`
const FeaturedEvents = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`
const DayEvents = styled.div`
  padding: 20px;
`
const NotificationArea = styled.div`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
`
const Notification = styled.div`
  display: flex;
  width:  46%;
  height: 120px;
  background-color: ${props => props.background};
  justify-content: center;
  align-items: center;
  margin: 2%;
  margin-bottom: 15px;
`
const Media = styled.div`
  display: flex;
  width: 46%;
  height: 120px;
  background-color: ${props => props.background};
  justify-content: center;
  align-items: center;
  margin: 2%;
  margin-bottom: 15px;
  border-radius: 30px;
`
const BottomBar = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${props => props.background};
  overflow: hidden;
  width: 100%;
  height: 56px;
`
const NavBarItem = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const WideViewItem = styled.div`
  height: 180px;
  width: 100%;
`
const Lotto = styled.div`
  display: flex;
  padding: 15px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export default class IPhoneView extends Component {

  loyaltyCard(header) {
    const loyal = this.props.theme.loyal;

    return (
      <LoyaltyCard styles={loyal}>
        <span style={{
          marginTop: -3,
          fontSize: 14,
          fontFamily: 'Lato-Regular',
          color: loyal.title,
        }}>
          {header}
        </span>
        <div style={{display: 'flex', marginTop: -7}}>
          <span style={{
            fontSize: 45,
            fontFamily: 'Lato-Bold',
            color: loyal.text}}>3/</span>
          <span style={{
            fontSize: 45,
            fontFamily: 'Lato-Black',
            color: loyal.text}}>10</span>
        </div>
        <span style={{
          fontFamily: 'Lato-Regular',
          color: loyal.text,
          marginBottom: 8,
        }}>7 points remaining until $2 OFF</span>
        <div style={{
          height: 10,
          width: '90%',
          backgroundColor: 'white',
          borderRadius: 5,
        }}>
          <div style={{
            borderRadius: 5,
            width: '30%',
            height: 10,
            backgroundColor: loyal.progress,
          }} />
        </div>
        <div style={{
          marginTop: 12,
          height: 35,
          width: 99,
          borderStyle: 'solid',
          borderWidth: 3,
          borderColor: 'white',
          borderRadius: 15,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <span style={{
            fontSize: 7,
            fontFamily: 'Arial',
            fontWeight: 'bold',
            color: 'white'
          }}> CHECK-IN</span>
        </div>
      </LoyaltyCard>
    )
  }

  featuredEvents(header) {
    const { theme } = this.props;

    const {
      card = {},
      datecircle = {},
      box = {},
      button = {},
    } = theme;

    return (
      <FeaturedEvents>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 25,
          marginBottom: 10
        }}>
          <span style={{
            color: '#767676',
            fontSize: 23,
            fontWeight: 'bold'
          }}>
            { header }
          </span>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: button.background,
            height: 21,
            width: 67
          }}>
            <span style={{
              color: button.text,
              fontSize: 8,
              fontFamily: 'Arial'
            }}>VIEW ALL</span>
          </div>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          height: 100,
          backgroundColor: card.background,
          alignItems: 'center',
          padding: 20
        }}>
          <div style={{
            height: 52,
            width: 52,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: datecircle.background,//'#3366FF'
            borderRadius: 26
          }}>
            <span style={{
              color: datecircle.text,
              fontSize: 18
            }}>6/6</span>
          </div>
          <span style={{
            color: card.title,
            fontSize: 29
          }}>Event Title</span>
          <span style={{
            color: card.subtitle,
            fontSize: 17
          }}>7AM - 9AM</span>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: 37,
          backgroundColor: box.background,
          alignItems: 'center',
          padding: 10,
          marginTop: 10
        }}>
          <div style={{
            height: 37,
            width: 37,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: datecircle.background,
            borderRadius: 18
          }}>
            <span style={{
              color: datecircle.text,
              fontSize: 12
            }}>6/9</span>
          </div>
          <span style={{
            color: box.title,
            fontSize: 20,
            width: '70%'
          }}>Event 1</span>
          <span style={{
            color: box.title,
            fontSize: 20
          }}>></span>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: 37,
          backgroundColor: box.background,
          alignItems: 'center',
          padding: 10,
          marginTop: 10
        }}>
          <div style={{
            height: 37,
            width: 37,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: datecircle.background,
            borderRadius: 18
          }}>
            <span style={{
              color: datecircle.text,
              fontSize: 12
            }}>6/11</span>
          </div>
          <span style={{
            color: box.title,
            fontSize: 20,
            width: '70%'
          }}>Event 2</span>
          <span style={{
            color: box.title,
            fontSize: 20
          }}>></span>
        </div>
      </FeaturedEvents>
    );
  }

  lottoCard(header) {
    const {
      theme
    } = this.props;

    const button = theme.button;
    return (
      <Lotto>
        <div style={{
          display: 'flex',
          width: '270px',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 25,
          marginBottom: 50,
        }}>
          <span style={{
            color: '#767676',
            fontSize: 23,
            fontWeight: 'bold'
          }}>
            { header }
          </span>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: button.background,
            height: 21,
            width: 67
          }}>
            <span style={{
              color: button.text,
              fontSize: 8,
              fontFamily: 'Arial'
            }}>VIEW ALL</span>
          </div>
        </div>
        <span>
          MEGA MILLIONS
        </span>
        <div style={{flexDirection: 'row', display: 'flex', marginBottom: 50}}>
          <div
            style={{
              width: 30,
              height: 30,
              borderWidth: 3,
              borderColor: 'yellow',
              borderStyle: 'solid',
              padding: 3,
              borderRadius: 50,
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex'
            }}
          >
            24
          </div>
          <div
            style={{
              width: 30,
              height: 30,
              borderWidth: 3,
              borderColor: 'yellow',
              borderStyle: 'solid',
              padding: 3,
              borderRadius: 50,
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex'
            }}
          >
            37
          </div>
          <div
            style={{
              width: 30,
              height: 30,
              borderWidth: 3,
              borderColor: 'yellow',
              borderStyle: 'solid',
              padding: 3,
              borderRadius: 50,
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex'
            }}
          >
            14
          </div>
          <div
            style={{
              width: 30,
              height: 30,
              borderWidth: 3,
              borderColor: 'yellow',
              borderStyle: 'solid',
              padding: 3,
              borderRadius: 50,
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex'
            }}
          >
            44
          </div>
          <div
            style={{
              width: 30,
              height: 30,
              borderWidth: 3,
              borderColor: 'yellow',
              borderStyle: 'solid',
              padding: 3,
              borderRadius: 50,
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex'
            }}
          >
            69
          </div>
        </div>
      </Lotto>
    )
  }

  newsCard(header) {
    const { theme } = this.props;

    const {
      card = {},
      datecircle = {},
      box = {},
      button = {},
    } = theme;

    return (
      <FeaturedEvents>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 25,
          marginBottom: 10
        }}>
          <span style={{
            color: '#767676',
            fontSize: 23,
            fontWeight: 'bold'
          }}>
            { header }
          </span>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: button.background,
            height: 21,
            width: 67
          }}>
            <span style={{
              color: button.text,
              fontSize: 8,
              fontFamily: 'Arial'
            }}>VIEW ALL</span>
          </div>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          height: 100,
          backgroundColor: card.background,
          alignItems: 'center',
          padding: 20
        }}>
          <div style={{
            height: 52,
            width: 52,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: datecircle.background,//'#3366FF'
            borderRadius: 26
          }}>
            <span style={{
              color: datecircle.text,
              fontSize: 18
            }}>6/1</span>
          </div>
          <span style={{
            color: card.title,
            fontSize: 29
          }}>Featured News</span>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: 37,
          backgroundColor: box.background,
          alignItems: 'center',
          padding: 10,
          marginTop: 10
        }}>
          <div style={{
            height: 37,
            width: 37,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: datecircle.background,
            borderRadius: 18
          }}>
            <span style={{
              color: datecircle.text,
              fontSize: 12
            }}>5/29</span>
          </div>
          <span style={{
            color: box.title,
            fontSize: 20,
            width: '70%'
          }}>News 1</span>
          <span style={{
            color: box.title,
            fontSize: 20
          }}>
            >
          </span>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: 37,
          backgroundColor: box.background,
          alignItems: 'center',
          padding: 10,
          marginTop: 10
        }}>
          <div style={{
            height: 37,
            width: 37,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: datecircle.background,
            borderRadius: 18
          }}>
            <span style={{
              color: datecircle.text,
              fontSize: 12
            }}>5/25</span>
          </div>
          <span style={{
            color: box.title,
            fontSize: 20,
            width: '70%'
          }}>News 2</span>
          <span style={{
            color: box.title,
            fontSize: 20
          }}>
            >
          </span>
        </div>
      </FeaturedEvents>
    );
  }

  announcements(header) {
    const { theme } = this.props;

    const {
      title = {},
    } = theme;

    let uri = title.front;

    return (
      <WideViewItem>
        <div style={{
          width: '100%',
          backgroundColor: 'orange',
          height: '180px',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <div style={{position: 'absolute' }}>
            <img
              src={ uri }
              alt={"Upload to Appearance to see img here"}
              width={ '300px' }
              height={ '180px' }
            />
          </div>
          <span style={{color: 'white', zIndex: 100}}>
            { header }
          </span>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderColor: 'white',
            borderWidth: 5,
            borderStyle: 'solid',
            height: 21,
            width: 92,
            zIndex: 100
          }}>
            <span style={{
               color: 'white',
               fontSize: 8,
               fontFamily: 'Arial'
            }}>
              VIEW
            </span>
          </div>
        </div>
      </WideViewItem>
    )
  }

  athletics(header) {
    const { theme } = this.props;

    const {
      title = {},
    } = theme;

    let uri = title.field;

    // TODO: add image background

    return (
      <WideViewItem>
        <div style={{
          width: '100%',
          backgroundColor: 'orange',
          height: '180px',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <div style={{position: 'absolute' }}>
            <img
              src={ uri }
              alt={"Upload in Appearance to see img here"}
              width={ '300px' }
              height={ '180px' }
            />
          </div>
          <span style={{color: 'white', zIndex: 100}}>
            { header }
          </span>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderColor: 'white',
            borderWidth: 5,
            borderStyle: 'solid',
            height: 21,
            width: 92,
            zIndex: 100
          }}>
            <span style={{
               color: 'white',
               fontSize: 8,
               fontFamily: 'Arial'
            }}>
              VIEW
            </span>
          </div>
        </div>
      </WideViewItem>
    )
  }

  dayEvents(header) {
    const { theme } = this.props;

    const {
      button = {},
    } = theme;

    return (
      <DayEvents>
        <div className={'header'} style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <span style={{
              color: '#767676',
              fontSize: 23,
              fontWeight: 'bold'
            }}>
              { header }
            </span>
            <br/>
            <span style={{
              color: '#767676',
              fontSize: 16,
              fontWeight: 'bold'
            }}>Monday</span>
          </div>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: button.background,
            height: 21,
            width: 92
          }}>
            <span style={{
               color: button.text,
               fontSize: 8,
               fontFamily: 'Arial'
            }}>VIEW CALENDAR</span>
          </div>
        </div>
        <div style={{
          height: 45,
          padding: 10,
          backgroundColor: '#F8F8F8',
          marginTop: 20
        }}>
          <span>Daily Special</span>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 15
        }}>
          <div style={{width: '39%'}}>
            <span>9AM-</span>
            <span>10AM</span>
          </div>
          <div style={{
            height: 43,
            width: '60%',
            backgroundColor: '#F8F8F8',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }} >
            <span>Event1</span>
          </div>
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 15
        }}>
          <div style={{width: '39%'}}>
            <span>1PM-</span>
            <span>3PM</span>
          </div>
          <div style={{
            height: 43,
            width: '60%',
            backgroundColor: '#F8F8F8',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }} >
            <span>Event2</span>
          </div>
        </div>
      </DayEvents>
    )
  }

  pageButtons(header) {
    const { theme } = this.props;

    const {
      box = {},
    } = theme;

    return (
      <NotificationArea>
        <Notification background={box.background}>
          <span style={{
            width: '100%',
            fontSize: 15,
            fontFamily: 'arial',
            fontWeight: 'bold',
            color: box.title,
            wrapWord: 'wrap',
            textAlign: 'center',
            flexDirection: 'column',
            display: 'flex'
          }}>
            <span>
              <NewsIcon />
            </span>
            <span>
              Newsletter
            </span>
          </span>
        </Notification>
        <Notification background={box.background}>
          <span style={{
            width: '100%',
            fontSize: 15,
            fontFamily: 'arial',
            fontWeight: 'bold',
            color: box.title,
            wrapWord: 'wrap',
            textAlign: 'center',
            flexDirection: 'column',
            display: 'flex'
          }}>
            <span>
              <NotifIcon />
            </span>
            <span>
              Notifications
            </span>
          </span>
        </Notification>
      </NotificationArea>
    );
  }

  socialMedia(header) {
    const { theme } = this.props;

    const {
      box = {},
    } = theme;

    return (
      <NotificationArea>
        <Media background={box.background}>
          <span style={{
            width: '100%',
            fontSize: 15,
            fontFamily: 'arial',
            fontWeight: 'bold',
            color: box.title,
            wrapWord: 'wrap',
            textAlign: 'center',
            flexDirection: 'column',
            display: 'flex'
          }}>
            <span>
              <FaceIcon />
            </span>
            <span>
              Facebook
            </span>
          </span>
        </Media>
        <Media background={box.background}>
          <span style={{
            width: '100%',
            fontSize: 15,
            fontFamily: 'arial',
            fontWeight: 'bold',
            color: box.title,
            wrapWord: 'wrap',
            textAlign: 'center',
            flexDirection: 'column',
            display: 'flex'
          }}>
            <span>
              <CameraIcon />
            </span>
            <span>
              Instagram
            </span>
          </span>
        </Media>
      </NotificationArea>
    );
  }

  /*
  announcements - Announcements
  lotto - LottoCard
  sports - Athletics
  coupons - CouponCard
  friends - FriendCard
  specialcard - SpecialCard
  socialmedia - SocialMedia
  newscard - LatestNews
  locationcard - LocationCard
  */

  bottomBar() {
    const { theme } = this.props;

    const {
      bottom = {},
    } = theme;

    return (
      <BottomBar background={bottom.background}>
        <NavBarItem>
          <span style={{
            fontSize: 9,
            color: bottom.text
          }}>Home</span>
        </NavBarItem>
        <NavBarItem>
          <span style={{
            fontSize: 9,
            color: bottom.text
          }}>Notification</span>
        </NavBarItem>
        <NavBarItem>
          <span style={{
            fontSize: 9,
            color: bottom.text
          }}>Rewards</span>
        </NavBarItem>
        <NavBarItem>
          <span style={{
            fontSize: 9,
            color: bottom.text
          }}>Calendar</span>
        </NavBarItem>
        <NavBarItem>
          <span style={{
            fontSize: 9,
            color: bottom.text
          }}>More</span>
        </NavBarItem>
      </BottomBar>
    );
  }

  couponCard(header) {
    const {
      theme
    } = this.props;

    const button = theme.button;

    return (
      <Lotto>
        <div style={{
          display: 'flex',
          width: '270px',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 25,
          marginBottom: 20,
        }}>
          <span style={{
            color: '#767676',
            fontSize: 23,
            fontWeight: 'bold'
          }}>
            { header }
          </span>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: button.background,
            height: 21,
            width: 67
          }}>
            <span style={{
              color: button.text,
              fontSize: 8,
              fontFamily: 'Arial'
            }}>VIEW ALL</span>
          </div>
        </div>
        <div style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          display: 'flex',
          marginBottom: 15
        }}>
          <div style={{
            height: 120,
            width: 80,
            backgroundColor: '#39e600',
            borderWidth: 1,
            borderColor: 'black',
            borderStyle: 'solid',
            textAlign: 'center',
          }}>
            <div style={{
              width: 80,
              height: 60,
              backgroundColor: 'white'
            }}>
              <div style={{
                height: 60,
                width: 80,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <CouponIcon />
              </div>
            </div>
            $1 COKE
          </div>
          <div style={{
            height: 120,
            width: 80,
            backgroundColor: '#39e600',
            borderWidth: 1,
            borderColor: 'black',
            borderStyle: 'solid',
            textAlign: 'center',
          }}>
            <div style={{
              width: 80,
              height: 60,
              backgroundColor: 'white'
            }}>
              <div style={{
                height: 60,
                width: 80,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <CouponIcon />
              </div>
            </div>
            $2 PIZZA
          </div>
          <div style={{
            height: 120,
            width: 80,
            backgroundColor: '#39e600',
            borderWidth: 1,
            borderColor: 'black',
            borderStyle: 'solid',
            textAlign: 'center',
          }}>
            <div style={{
              width: 80,
              height: 60,
              backgroundColor: 'white'
            }}>
              <div style={{
                height: 60,
                width: 80,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <CouponIcon />
              </div>
            </div>
            HALF OFF SALAMI
          </div>
        </div>
      </Lotto>
    )
  }

  community(header) {
    const {
      theme
    } = this.props;

    const button = theme.button;

    return (
      <Lotto>
        <div style={{
          display: 'flex',
          width: '270px',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 25,
          marginBottom: 20,
        }}>
          <span style={{
            color: '#767676',
            fontSize: 23,
            fontWeight: 'bold'
          }}>
            { header }
          </span>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: button.background,
            height: 21,
            width: 67
          }}>
            <span style={{
              color: button.text,
              fontSize: 8,
              fontFamily: 'Arial'
            }}>VIEW ALL</span>
          </div>
        </div>
        <div style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          display: 'flex',
          marginBottom: 15
        }}>
          <div style={{
            width: 120,
            height: 120,
            backgroundColor: button.background,
            borderWidth: 1,
            borderColor: 'black',
            borderStyle: 'solid',
            textAlign: 'center',
            color: 'white',
          }}>
            <div style={{
              width: 120,
              height: 80,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'white',
              color: button.background,
            }}>
              <FriendIcon />
            </div>
            Friend #1
          </div>
          <div style={{
            width: 120,
            height: 120,
            backgroundColor: button.background,
            borderWidth: 1,
            borderColor: 'black',
            borderStyle: 'solid',
            textAlign: 'center',
            color: 'white',
          }}>
            <div style={{
              width: 120,
              height: 80,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'white',
              color: button.background,
            }}>
              <FriendIcon />
            </div>
            Friend #2
          </div>
        </div>
      </Lotto>
    )
  }

  specialCard(header) {
    const {
      theme
    } = this.props;

    const button = theme.button;

    return (
      <Lotto>
        <div style={{
          display: 'flex',
          width: '270px',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 25,
          marginBottom: 20,
        }}>
          <span style={{
            color: '#767676',
            fontSize: 23,
            fontWeight: 'bold'
          }}>
            { header }
          </span>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: button.background,
            height: 21,
            width: 67
          }}>
            <span style={{
              color: button.text,
              fontSize: 8,
              fontFamily: 'Arial'
            }}>VIEW ALL</span>
          </div>
        </div>
        <div style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          display: 'flex',
          marginBottom: 15
        }}>
          <div style={{
            width: 120,
            height: 120,
            backgroundColor: button.background,
            borderWidth: 1,
            borderColor: 'black',
            borderStyle: 'solid',
            textAlign: 'center',
            color: 'white',
          }}>
            <div style={{
              width: 120,
              height: 80,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'white',
              color: button.background,
            }}>
              <SpecialIcon />
            </div>
            Special #1
          </div>
          <div style={{
            width: 120,
            height: 120,
            backgroundColor: button.background,
            borderWidth: 1,
            borderColor: 'black',
            borderStyle: 'solid',
            textAlign: 'center',
            color: 'white',
          }}>
            <div style={{
              width: 120,
              height: 80,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'white',
              color: button.background,
            }}>
              <SpecialIcon />
            </div>
            Special #2
          </div>
        </div>
      </Lotto>
    )
  }

  locationCard(header) {
    const {
      theme
    } = this.props;

    const button = theme.button;

    return (
      <Lotto>
        <div style={{
          display: 'flex',
          width: '270px',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 25,
          marginBottom: 20,
        }}>
          <span style={{
            color: '#767676',
            fontSize: 23,
            fontWeight: 'bold'
          }}>
            { header }
          </span>
          <div style={{
            borderRadius: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: button.background,
            height: 21,
            width: 67
          }}>
            <span style={{
              color: button.text,
              fontSize: 8,
              fontFamily: 'Arial'
            }}>VIEW ALL</span>
          </div>
        </div>
        <div style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          display: 'flex',
          marginBottom: 15
        }}>
          <div style={{
            width: 120,
            height: 120,
            backgroundColor: button.background,
            borderWidth: 1,
            borderColor: 'black',
            borderStyle: 'solid',
            textAlign: 'center',
            color: 'white',
          }}>
            <div style={{
              width: 120,
              height: 80,
              backgroundColor: 'white'
            }}>
              <div style={{
                marginLeft: 20,
                height: 80,
                width: 80,
                borderRadius: 40,
                backgroundColor: '#39e600',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <MapIcon />
              </div>
            </div>
            Location #1
          </div>
          <div style={{
            width: 120,
            height: 120,
            backgroundColor: button.background,
            borderWidth: 1,
            borderColor: 'black',
            borderStyle: 'solid',
            textAlign: 'center',
            color: 'white',
          }}>
            <div style={{
              width: 120,
              height: 80,
              backgroundColor: 'white'
            }}>
              <div style={{
                marginLeft: 20,
                height: 80,
                width: 80,
                borderRadius: 40,
                backgroundColor: '#39e600',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
                <MapIcon />
              </div>
            </div>
            Location #2
          </div>
        </div>
      </Lotto>
    )
  }

  render () {
    const { theme, home } = this.props;

    const {
      title = {},
      general = {},
    } = theme;

    var display = [];
    if (Array.isArray(home)) {
      for (let h = 0; h < home.length; ++h) {
        let key = home[h].key;
        let value = home[h].value;
        switch(key) {
          case 'loyalty':
            display.push(
              this.loyaltyCard(value)
            );
            break;
          case 'eventcard':
            display.push(
              this.featuredEvents(value)
            );
            break;
          case 'dayevents':
            display.push(
              this.dayEvents(value)
            );
            break;
          case 'pagebuttons':
            display.push(
              this.pageButtons(value)
            );
            break;
          case 'announcements':
            display.push(
              this.announcements(value)
            );
            break;
          case 'lotto':
            display.push(
              this.lottoCard(value)
            );
            break;
          case 'sports':
            display.push(
              this.athletics(value)
            );
            break;
          case 'coupons':
            display.push(
              this.couponCard(value)
            );
            break;
          case 'friends':
            display.push(
              this.community(value)
            );
            break;
          case 'specialcard':
            display.push(
              this.specialCard(value)
            );
            break;
          case 'socialmedia':
            display.push(
              this.socialMedia(value)
            );
            break;
          case 'newscard':
            display.push(
              this.newsCard(value)
            );
            break;
          case 'locationcard':
            display.push(
              this.locationCard(value)
            );
            break;
          default:
            break;
        }
      }
    }

    return (
      <IPhone>
        <IPhoneScreen background={general.background}>
          <TitleBar styles={title}>
            <div
              className="logo-upload-button"
              style={{
                backgroundImage: `url("${title.logo}")`,
              }} />
          </TitleBar>
          { display }
          { this.bottomBar() }
        </IPhoneScreen>
      </IPhone>
    );
  }
}
